/**
 * De tijdzone van de ingelogde gebruiker, voor plannen en tonen.
 *
 * 07-10-2026 (Jordy): "zodat chatters in hun eigen tijdzone kunnen plannen".
 * De voorkeur staat per login in admin_users.ui_prefs (sleutel "timezone",
 * via /auth/me) en wordt gezet in Settings → Edit user of Chatters → Edit
 * chatter. Zonder voorkeur (of met een zone die de browser niet kent) is het
 * Europe/Amsterdam, zoals vóór deze wijziging.
 */
import { useEffect, useRef } from 'react'
import { AMSTERDAM, geldigeZone } from './amsterdam'
import { useMij } from './rechten'

/** De zone van de ingelogde gebruiker (Amsterdam zolang /me nog laadt). */
export function useMijnZone(): string {
  return geldigeZone(useMij().data?.timezone)
}

/**
 * Roept `omzetten(van, naar)` aan als de zone wisselt (bv. als /me binnenkomt
 * met Asia/Manila, of na een keuze op de pagina), zodat ingevulde datums en
 * tijden hetzelfde moment blijven aanduiden.
 */
export function useBijZoneWissel(zone: string, omzetten: (van: string, naar: string) => void): void {
  const vorige = useRef(zone)
  const terug = useRef(omzetten)
  terug.current = omzetten
  useEffect(() => {
    if (vorige.current === zone) return
    const van = vorige.current
    vorige.current = zone
    terug.current(van, zone)
  }, [zone])
}

/** Bovenaan de keuzelijst; daarna alle zones die de browser kent. */
export const VASTE_ZONES = [AMSTERDAM, 'Asia/Manila']

export function alleZones(): string[] {
  let lijst: string[] = []
  try {
    const intl = Intl as unknown as { supportedValuesOf?: (k: string) => string[] }
    lijst = intl.supportedValuesOf ? intl.supportedValuesOf('timeZone') : []
  } catch {
    lijst = []
  }
  return [...VASTE_ZONES, ...lijst.filter((z) => !VASTE_ZONES.includes(z))]
}
